import { render, staticRenderFns } from "./ProgramSetting.vue?vue&type=template&id=2f60f53a&scoped=true"
import script from "./ProgramSetting.vue?vue&type=script&lang=js"
export * from "./ProgramSetting.vue?vue&type=script&lang=js"
import style1 from "./ProgramSetting.vue?vue&type=style&index=1&id=2f60f53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60f53a",
  null
  
)

export default component.exports